
import { Box, Grid } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'


import { useHistory } from 'react-router-dom'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/**API */
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import { getBranch } from 'utils/app.utils'

/**COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import { useDownloadExcel } from 'component/Excel/hooks/useExcel'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import Loading from 'component/Loading'

/**STYLE */
import ComponentApi from 'api/components-api'
import SearchPatients from 'component/SearchPatients'
import * as UseStyled from 'features/report/useStyled'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import AccountingCodeList from './AccountingCodeList'

type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
}

export interface DentistInterface {
  dentistId: number
  dentistFullname: string
}

export default function AccountingCode() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<HTMLDivElement>(null)
  const momentNowRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const momentDate = () => momentNowRange
  const [branchId, setBranchId] = useState<any>(getBranch())
  const [branches, setBranches] = useState<any[]>([])
  const [operativeCode, setOperativeCode] = useState<any[]>([])
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')
  const [doctors, setDoctors] = useState<Doctors[]>([])
  const [fetch, setFetch] = useState(false)
  const [rows, setRows] = useState<any[]>([])
  const [rowsExport, setRowsExport] = useState<any[]>([])
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
  const [page, setPage] = useState<number>(1)
  const [pageLimit, setPageLimit] = useState<number>(10)
  const [loading, setLoading] = useState<boolean>(true)
  const [selectDoctors, setSelectDoctors] = useState<any[]>([])
  const [billStatus, setBillStatus] = useState<string>('ALL')
  const [patientFilter, setPatientFilter] = useState<string>(t('REPORT.REPORT_GROUP.ALL'))
  const [patientId, setPatientId] = useState<number>(0)
  const [codeForm, setCodeForm] = useState<{ operativeCode: string }>({ operativeCode: '' })
  const [codeTo, setCodeTo] = useState<{ operativeCode: string }>({ operativeCode: '' })
  const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([])
  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

  const handleFilterDoctors = (value: any) => {
    if ((value === 'ALL' && _.size(selectDoctors.filter((item) => typeof item === 'number')) === _.size(doctors)) || value === 'CLEAR') setSelectDoctors([''])
    else if (value === 'ALL') setSelectDoctors(['ALL', ..._.map(doctors, (d: any) => d.userId)])
    else if (_.includes(selectDoctors, value)) setSelectDoctors(_.filter(selectDoctors, (d) => d !== value && d !== 'ALL'))
    else setSelectDoctors([...selectDoctors, value])
  }

  const getFilterUser = () => {
    if (_.includes(selectDoctors, 'ALL')) return ` ${t('REPORT.REPORT_GROUP.ALL')}`
    else {
      return ` ${doctorsMultiple
        .filter((d: DentistInterface) => selectDoctors.includes(d.dentistId))
        ?.map((d: DentistInterface) => d.dentistFullname)
        .join(', ')}`
    }
  }

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    // ReportApi.reportList(condition).then(({ data }) => {
    //   const check = _.find(data, (val: any) => String(val.reportKey) === 'DF_LAB') ? true : false
    //   if (!check) {
    //     history.push(routeName.report)
    //     return false
    //   }
    // })

    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })
    ComponentApi.findAllOperativeCode()
      .then(({ data }) => setOperativeCode(data))
      .catch((e) => {
        return
      })
    ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1])
      .then((resp) => {
        setDoctors([...resp.data])
        setSelectDoctors(['ALL', ...resp.data.map((d: any) => d.userId)])
      })
      .catch((e) => {
        return
      })

    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [branchId])

  const fetchDF = useCallback(async () => {
    let condition: any = {
      page: page,
      pageLimit: pageLimit,
      branchId: branchId,
      patientId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      billStatus: billStatus === 'ALL' ? '' : billStatus
    }
    if (selectDoctors.length) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (selectDoctors[0] !== "ALL" && doctor) condition = { ...condition, doctorId: doctor }
    }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }

    ReportApi.reportAccountingCode(condition)
      .then(({ headers, data }) => {
        setRows(data.rows)
      })
    //   .catch((e) => setLoading(false))
    //   .finally(() => {
    //     setLoading(false)
    //   })
    // setFetch(false)
  }, [page, pageLimit, sortBy, sortType, fetch])
  const fetchDFExport = useCallback(async () => {
    let condition: any = {
      page: page,
      pageLimit: pageLimit,
      branchId: branchId,
      patientId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      billStatus: billStatus === 'ALL' ? '' : billStatus,
      export: 1
    }
    if (selectDoctors.length) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (selectDoctors[0] !== "ALL" && doctor) condition = { ...condition, doctorId: doctor }
    }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }

    ReportApi.reportAccountingCode(condition)
      .then(({ headers, data }) => {
        setRowsExport(data.rows)
        setRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => {
        setLoading(false)
      })
    setFetch(false)
  }, [page, pageLimit, sortBy, sortType, fetch])

  const { onDownload } = useDownloadExcel({
    tableExportRef: componentRef.current,
    filename: `${t(`REPORT.REPORT_NAME.ACCOUNTING_CODE`)}`,
    sheetName: `${t(`REPORT.REPORT_NAME.ACCOUNTING_CODE`)}`
  })

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

  const handleChangePage = (val: number) => setPage(val)

  useEffect(() => {
    fetchDF()
  }, [fetchDF])
  useEffect(() => {
    fetchDFExport()
  }, [fetchDFExport])


  const handleClear = () => setPatientId(0)


  return (
    <Box sx={{ height: '100%' }}>
      <HeaderCard text={t('Accounting Code Report')} />
      <Box sx={{ px: 3, pt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <InputSecondNewRangePicker
              value={rangeDate || emptyRangePicker}
              onchange={val => {
                if (_.isEmpty(val)) setRangeDate(emptyRangePicker);
                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]);
              }}
              label=""
              inputHeight={40}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={3}>
            <SearchPatients
              status="ACTIVE"
              callbackPatientId={setPatientId}
              patientId={patientId}
              onClear={handleClear}
              callbackPatientName={setPatientFilter}
              bodyHeight={40}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              label={t('REPORT.FILTER.RECEIPT_STATUS')}
              value={billStatus}
              onChange={e => {
                setBillStatus(e.target.value);
                setPage(1);
              }}
              options={[
                { value: 'ALL', name: t('REPORT.FILTER.ALL') },
                { value: 'PAID', name: t('REPORT.FILTER.BILL.PAID') },
                { value: 'CANCEL', name: t('REPORT.FILTER.BILL.CANCEL') },
              ]}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} md={1} xl={1}>
            <MainButton
              title={t('INPUT.SEARCH')}
              type="primary"
              variant="contained"
              onClick={() => {
                setFetch(true);
                setPage(1);
                setLoading(true);
              }}
              style={{ width: '120px' }}
            />
          </Grid>
          <Grid item xs={12} md={2} xl={4} sx={{ display: 'flex', justifyContent: 'flex-end', ml: 'auto' }}>
            <UseStyled.DropdownDocument>
              <Dropdown.Toggle id="dropdown-basic" className="ml-auto">
                {t('REGISTER.BUTTON.PRINT_DOCUMENT')}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={onDownload}>{t('Excel')}</Dropdown.Item>
              </Dropdown.Menu>
            </UseStyled.DropdownDocument>
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, px: { xs: 1 }, pb: 4 }}>
          <AccountingCodeList
            page={page}
            pageLimit={pageLimit}
            rowCount={rowCount}
            sortBy={sortBy}
            sortType={sortType}
            data={rows}
            dataExport={rowsExport}
            onRequestSort={onRequestSort}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            setSortType={setSortType}
            setSortBy={setSortBy}
            componentRef={componentRef}
          />
        </Box>
      </Box>
      <Loading show={loading} type="fullLoading" />
    </Box>
  );
}
